<template>
  <div>
    <h2>Connect {{ source.label }} account</h2>
    <p class="flow-text">To connect Retribute to your {{ source.label }} account, fill in the form below and follow the instructions.</p>
    <component :is="source.form"></component>
  </div>
</template>

<script>
import sources from "@/sources"

export default {
  props: ['sourceId'],
  computed: {
    source () {
      return sources.sources[this.sourceId]
    }
  }
}
</script>
<style scoped>
.card .card-image {
  padding: 1em;
}
</style>
